<div class="text-center" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="32px">
  <section fxLayout fxLayoutAlign="start center" fxLayoutGap="9px">
    <img src="/assets/images/connected-accounts/agoda.svg" alt="Agoda Logo" class="agoda-logo" />

    <div class="success-separator"></div>

    <img [src]="'assets/iconography/arrow-right.svg'" width="52px" height="52px" />

    <div class="success-separator"></div>

    <svg width="82" height="110" viewBox="0 0 41 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.5 41.6931C31.8218 41.6931 41 32.496 41 21.1507C41 9.80552 31.8218 0.608398 20.5 0.608398C9.17816 0.608398 0 9.80552 0 21.1507C0 32.496 9.17816 41.6931 20.5 41.6931ZM20.5 33.4764C27.2931 33.4764 32.8 27.9581 32.8 21.151C32.8 14.3439 27.2931 8.8256 20.5 8.8256C13.7069 8.8256 8.2 14.3439 8.2 21.151C8.2 27.9581 13.7069 33.4764 20.5 33.4764ZM28.7784 45.8445H12.3454C10.0765 45.8445 8.23715 47.6895 8.23715 49.9654C8.23715 52.2413 10.0765 54.0863 12.3454 54.0863H28.7784C31.0474 54.0863 32.8867 52.2413 32.8867 49.9654C32.8867 47.6895 31.0474 45.8445 28.7784 45.8445Z"
        fill="#ED3C6A" />
    </svg>
  </section>

  <section fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start center">
    <h2>Unable to import property</h2>
    <span class="text-center width-500" *ngIf="failed === 'multipleRooms'">
      We are unable to import your property because we cannot support multi-inventory listings or units at this time.
    </span>
  </section>
</div>
<div
  style="margin-top: 42px"
  fxLayout
  fxLayoutGap="24px"
  fxLayoutAlign="center center"
  *ngIf="failed === 'multipleRooms'">
  <button id="connect-success-primary" mat-flat-button (click)="finish()">Finish (take me to properties)</button>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="center center">
  <button id="connect-another" mat-flat-button (click)="connectAnother()" class="button__secondary">
    Connect another property
  </button>
</div>
